import { Component, type ReactNode, type ErrorInfo } from 'react';
import { AlertCircle } from 'lucide-react';

interface Props { children: ReactNode; fallback?: ReactNode; }
interface State { hasError: boolean; error?: Error; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="flex flex-col items-center justify-center p-8 text-center">
          <AlertCircle size={48} className="text-brand-danger mb-4" />
          <h2 className="text-lg font-semibold text-text-primary mb-2">Algo salió mal</h2>
          <p className="text-sm text-text-secondary mb-4">
            Ocurrió un inconveniente inesperado al cargar esta sección. Por favor, pulsa el botón para reintentar.
          </p>
          <button
            onClick={() => this.setState({ hasError: false })}
            className="px-4 py-2 bg-brand-primary text-white rounded-lg text-sm font-medium"
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
